class CollectionShoppableVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadElements();
    this.loadEvents();
  }

  async addToCart(variantId) {
    this.setCtaAddingProduct(true);
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    try {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.log(`Collection Shoppable Video | ${error}`);
    } finally {
      this.setCtaAddingProduct(false);
    }
  }

  addToCartEventHandler(event) {
    const btn = event.target.closest("button");
    if (!btn) return;
    const { variantId } = btn.dataset;
    this.addToCart(variantId);
  }

  loadEvents() {
    this.cta.addEventListener("click", this.addToCartEventHandler.bind(this));
  }

  loadElements() {
    this.cta = this.querySelector(".collection-shoppable-video--atc");
    this.ctaText = this.cta.querySelector(
      ".collection-shoppable-video--atc-text"
    );
  }

  setCtaAddingProduct(addingToCart = false) {
    this.ctaText.innerHTML = `
        ${addingToCart ? "Adding..." : "Add To Bag"}
    `;
  }

  disconnectedCallback() {
    this.cta.removeEventListener(
      "click",
      this.addToCartEventHandler.bind(this)
    );
  }
}
customElements.define("collection-shoppable-video", CollectionShoppableVideo);
